import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import CloudconsultCp from '../../homepage/consult/cloudconsult-cp';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CommonTable from '../../container/Table/Components/CommonTable';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../kubernetes/asset/css/style.css';
import '../../Style/typo.css'
import { Grid } from '@mui/material';
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import FooterEn from '../../detailpageVN/Page/component/footeren';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="12" height="12" fill="#7061ff"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>`
// Titlecloudcompute
function KubeBenefitsENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Advantages - Private Kubernetes - Private Cloud';
    }, []);

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("장점")} */}
                        {/* {Contentcloudcard(`Kubernetes 장점`)} */}

                        <MuiGrid item xs={12} sm={12}>{CardBoxRow(
                            "<p class='typo-21-sm typo-medium typo-black'>Kubernetes Advantages</p>",

                            `
                            <div class="kube-card-txt">
                                <ul>
                                    <li><p class='typo-14'>Build Kubernetes clusters on on-premises or private hosting servers.</p></li>
                                    <li><p class='typo-14'>Provide workload orchestration and auto-scaling equivalent to global cloud platforms.</p></li>
                                    <li><p class='typo-14'>Optimize resource utilization with support for both fixed and flexible cost structures.</p></li>
                                    <li><p class='typo-14'>Built-in support for integrated monitoring stacks like Prometheus and Grafana.</p></li>
                                    <li><p class='typo-14'>Supports persistent storage and volume management for both stateful and stateless workloads.</p></li>
                                    <li><p class='typo-14'>Allows internal network integration and customization of security policies.</p></li>
                                <ul>
                            </div>
                            <div class="kube-card-txt">
                                <ul>
                                    <li><p class='typo-14'>Efficient use of server resources.</p></li>
                                    <li><p class='typo-14'>Scale servers freely during operation (Autoscale).</p></li>
                                    <li><p class='typo-14'>Ensures continuous service without downtime during redeployment.</p></li>
                                    <li><p class='typo-14'>Automated cluster scaling and load balancing capabilities.</p></li>
                                    <li><p class='typo-14'>Application: Operating a microservice platform.</p></li>
                                <ul>
                            </div>
                            `)}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/kube-node.png")}</MuiGrid>
                        <DividerComponent />
                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>


            {/* <Cloudconsult /> */}
            <FooterEn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default KubeBenefitsENG;